/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/esnext.async-iterator.filter.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { useCreditStore } from '@/stores/modules/credit';
import { CreditStatus } from '@/shared/statusCode';
import { useRetainPopup } from '@/composables/useCreditCommon';
import { useBackButton } from '@/composables/clickAppBackBtn';
export default {
    __name: 'index',
    setup: function(__props) {
        var route = useRoute();
        var creditStore = useCreditStore();
        var goAppHomeSimple = useRetainPopup().goAppHomeSimple;
        var setupBackPressed = useBackButton().setupBackPressed;
        var list = ref([
            // 0 UNCREDITED
            {
                status: CreditStatus.UNCREDITED,
                title: 'Analizando información',
                content: [
                    'Por favor no cierre esta pantalla. La revisión tomará aproximadamente 1-2 minutos.'
                ],
                img: require('@/assets/img/result/in-review.png'),
                btn: null
            },
            // 1 CREDITING
            {
                status: CreditStatus.CREDITING,
                title: 'Analizando información',
                content: [
                    'La revisión tarda entre 1 y 2 minutos y los resultados se pueden encontrar en la página de inicio.'
                ],
                img: require('@/assets/img/result/in-review.png'),
                btn: null
            },
            // 4 LENDING
            {
                status: CreditStatus.LENDING,
                title: 'Procesando la liberación',
                content: [
                    'Estamos procesando tu liberación. Espera un momento. Los fondos estarán disponibles pronto.'
                ],
                img: require('@/assets/img/result/loaning.png'),
                btn: null
            },
            // 5 LEND_FAILED -- android can't go here
            {
                status: CreditStatus.LEND_FAILED,
                title: 'Retiro fallido',
                content: [
                    '¡Uy! Hubo un problema con tu retiro.',
                    'Por favor, vuelva primero a la página de inicio.'
                ],
                img: require('@/assets/img/result/loan-fail.png')
            },
            // 6 LEND_FAILED_WITH_NOT_ALLOWED_RETRY -- android can't go here
            {
                status: CreditStatus.LEND_FAILED_WITH_NOT_ALLOWED_RETRY,
                title: 'Retiro fallido',
                content: [
                    '¡Uy! Hubo un problema con tu retiro.',
                    'Por favor, vuelva primero a la página de inicio.'
                ],
                img: require('@/assets/img/result/loan-fail.png')
            },
            // 7 REPAYING == loan success
            {
                status: CreditStatus.REPAYING,
                title: 'Retiro exitoso',
                content: [
                    'Puedes consultar la cuenta bancaria para verificar el importe.',
                    'Pagar a tiempo es bueno para tu crédito.'
                ],
                img: require('@/assets/img/result/loan-success.png')
            },
            // 9 NEED_FACE_RECOGNITION -- android can't go here
            {
                status: CreditStatus.NEED_FACE_RECOGNITION,
                title: 'Reconocimiento facial',
                content: [
                    'Completa el reconocimiento facial antes de proceder con la solicitud de préstamo'
                ],
                img: require('@/assets/img/result/restock-face.png'),
                btn: 'Empezar a identificar'
            },
            // 10 FACE_RECOGNITIONING_LIMIT_EXCEEDED
            {
                status: CreditStatus.FACE_RECOGNITIONING_LIMIT_EXCEEDED,
                title: 'Lo sentimos',
                content: [
                    "Ha excedido el limite de intentos de reconocmiento facial, int\xe9ntelo el ".concat(route.query.retryPlan)
                ],
                img: require('@/assets/img/result/face-limit.png'),
                btn: null
            }
        ]);
        var currCode = ref(1);
        var currObj = computed(function() {
            var arr = list.value.filter(function(item) {
                return item.status === currCode.value;
            })[0];
            return arr;
        });
        var init = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var clientState;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                creditStore.reqCreditStatus()
                            ];
                        case 1:
                            clientState = _state.sent();
                            currCode.value = clientState;
                            // currCode.value = 9;
                            console.log(currCode.value);
                            console.log(currObj.value);
                            if (currCode.value === CreditStatus.UNCREDITED || currCode.value === CreditStatus.CREDITING || currCode.value === CreditStatus.LENDING) {
                                setTimeout(function() {
                                    init();
                                }, 1000 * 10);
                            } else if (currCode.value === CreditStatus.PASSED || currCode.value === CreditStatus.REPAYING || currCode.value === CreditStatus.LOANING_REJECTED || currCode.value === CreditStatus.NO_LOAN_REJECTED) {
                                pushPage();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function init() {
                return _ref.apply(this, arguments);
            };
        }();
        init();
        var pushPage = function() {
            goAppHomeSimple();
        };
        onMounted(function() {
            setupBackPressed();
        });
        return {
            __sfc: true,
            route: route,
            creditStore: creditStore,
            goAppHomeSimple: goAppHomeSimple,
            setupBackPressed: setupBackPressed,
            list: list,
            currCode: currCode,
            currObj: currObj,
            init: init,
            pushPage: pushPage
        };
    }
};
